import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import fileEdit from "../utils/fileEdit.png";
import file from "../utils/file.svg";
// import checkedList from "../utils/checkedList.png";

import {
  AiOutlineForm,
  AiOutlineInteraction,
  AiOutlineExport,
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlineSetting,
  AiOutlineCheckCircle,
  AiOutlineTeam,
  AiOutlineStock,
  AiOutlineFileText, // Document-style quotation icon
  AiOutlineMessage, // Message-style quotation icon
  BiCommentDetail, // Alternative quotation icon
  MdOutlineRequestQuote,
} from "react-icons/ai";
// import { AiOutlineEdit, AiFillEdit } from "react-icons/ai";

import { GrAnalytics } from "react-icons/gr";

// import * as React from 'react';
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import "../css/Sidebar.css"




const Sidebar = ({ isOpen }) => {


  const [accessGroup, setAccessGroup] = useState("")

  const [hideLeftSideBar, setHideLeftSideBar] = useState(true)

  const toggleLeftSideBar = () => {
    setHideLeftSideBar(prev => !prev)
  }


  const [showSampleRequestMenu, setShowSampleRequestMenu] = useState(false)

  useEffect(() => {


    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));

    const userAccessGroup = currentUserObject[0].accessgrp;

    setAccessGroup(userAccessGroup)

    if (userAccessGroup?.trim().toUpperCase() === "ADMIN" || userAccessGroup?.trim().toUpperCase() === "CADMIN" || userAccessGroup?.trim().toUpperCase() === "CACCOUNTS" || userAccessGroup?.trim().toUpperCase() === "C ACC JUNIOR") {
      setShowSampleRequestMenu(true)
    }
  }, [])

  const navigate = useNavigate()

  const onSignOut = () => {
    //  clear other keys except company code , private key , public key so clear only particular keys
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserName');
    localStorage.removeItem('currentUserEmployeeID');
    localStorage.removeItem('currentSelectedDepartment');
    localStorage.removeItem('currentUserLoginStatus');

    navigate('/')
  }


  return (


    <div>

      <button className="buttonToggleLeftSide" onClick={() => toggleLeftSideBar()}>&#187;</button>

      <aside
        // ${isOpen ? 'w-1/6' : 'w-16'}
        className={hideLeftSideBar ? `fixed top-0 left-0 h-full w-24 h-screen overflow-y-auto scrollbar-hide
           px-4   transition-all duration-300 ease-in-out hide-left-sidebar` : `fixed top-0 left-0 h-full w-24 h-screen overflow-y-auto scrollbar-hide
           px-4   transition-all duration-300 ease-in-out left-sidebar-on-mobile`}
        style={{ zIndex: 10, backgroundColor: "#f8f8f8" }}
      >


        <ul className="space-y-2.5 flex flex-col justify-center items-start w-[65px] mt-40">

          {
            accessGroup?.trim().toUpperCase() === "CADMIN" &&

            <li className="flex justify-center gap-10 text-center items-center bg-white rounded shadow p-1 pl-1 w-full">
              <NavLink
                to="/home"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium text-indigo-500 flex items-center"
                    : "font-medium flex items-center"
                }
              >
                <div className="flex flex-col justify-center items-center p-1">
                  <GrAnalytics className="w-6 h-6" />
                  <span className="text-xs">Analytics</span>
                </div>

                {/* <AiOutlineHome  />           */}
                {/* {isOpen && 
<span className='ml-2'>Home</span>  
} */}
              </NavLink>
            </li>
          }


          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full ">
            <NavLink
              to="/leads"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center p-1">
                <AiOutlineUser className="w-6 h-6" />
                <span className="text-xs">Leads</span>
              </div>

              {/* <AiOutlineUser/> */}
              {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } */}
            </NavLink>
          </li>

          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full">
            <NavLink
              to="/qualifiedLeadsTable"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center text-center p-1">
                <AiOutlineCheckCircle className="w-6 h-6" />
                <span className="text-xs transform scale-90">
                  Qualified Leads
                </span>
              </div>

              {/* <AiOutlineCheckCircle   /> */}
              {/* {isOpen && 
        <span className='ml-2'>Qualified Leads</span>  
           } */}
            </NavLink>
          </li>

          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full mb-4">
            <NavLink
              to="/deals"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center p-1">
                {/* <AiOutlineUsergroupAdd className='w-6 h-6' />           */}
                <AiOutlineInteraction className="w-6 h-6" />
                <span className="text-xs">Deals</span>
              </div>

              {/* <AiOutlineUser/> */}
              {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } */}
            </NavLink>
          </li>

          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full mb-4">
            <NavLink
              to="/stockList"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center p-1">
                {/* <AiOutlineUsergroupAdd className='w-6 h-6' />           */}
                <AiOutlineStock className="w-6 h-6" />
                <span className="text-xs">Stock List</span>
              </div>

              {/* <AiOutlineUser/> */}
              {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } */}
            </NavLink>
          </li>

          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full mb-4">
            <NavLink
              to="/quotationsListViewFull"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center p-1">
                {/* <AiOutlineUsergroupAdd className='w-6 h-6' />           */}
                <AiOutlineStock className="w-6 h-6" />
                <span className="text-xs">Quotation List</span>
              </div>

              {/* <AiOutlineUser/> */}
              {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } */}
            </NavLink>
          </li>

          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full mb-4">
            <NavLink
              to="/salesOrderListViewFull"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center p-1">
                {/* <AiOutlineUsergroupAdd className='w-6 h-6' />           */}
                <AiOutlineStock className="w-6 h-6" />
                <span className="text-xs">Sales Order List</span>
              </div>

              {/* <AiOutlineUser/> */}
              {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } */}
            </NavLink>
          </li>
          {
            showSampleRequestMenu &&
            <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full mb-4">
              <NavLink
                to="/sampleRequestListViewFull"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium text-indigo-500 flex items-center"
                    : "font-medium flex items-center"
                }
              >
                <div className="flex flex-col justify-center items-center p-1">
                  {/* <AiOutlineUsergroupAdd className='w-6 h-6' />           */}
                  <AiOutlineStock className="w-6 h-6" />
                  <span className="text-xs">Sample Request List</span>
                </div>

                {/* <AiOutlineUser/> */}
                {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } */}
              </NavLink>
            </li>
          }

          {
            showSampleRequestMenu &&
            <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full mb-4">
              <NavLink
                to="/workOrderListViewFull"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium text-indigo-500 flex items-center"
                    : "font-medium flex items-center"
                }
              >
                <div className="flex flex-col justify-center items-center p-1">
                  {/* <AiOutlineUsergroupAdd className='w-6 h-6' />           */}
                  <AiOutlineStock className="w-6 h-6" />
                  <span className="text-xs">Work Order List</span>
                </div>

                {/* <AiOutlineUser/> */}
                {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } */}
              </NavLink>
            </li>
          }

          {/* /////////////////////Quotation //////////////////////////////////////////// */}

          {/* <Accordion sx={{ background: "#dedede", boxShadow: "none", paddingRight:"4px", paddingLeft:"4px" ,  borderRadius:'8px',width:'65px' , marginTop:'0px', paddingTop:'0px' }}>
          <AccordionSummary
            // expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              padding: '0px',
              margin: '0px',
              "& .MuiAccordionSummary-content": {
                margin: "4px !important",
                padding: "0px",
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                padding: '0px !important',
                margin: '0px !important '
              },
              "& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded":{
                // minHeight:'55px'
              },
              "& .MuiPaper-root-MuiAccordion-root.Mui-expanded:first-of-type":{
                marginTop:'0px'
              }
            }}
          >
            <Typography component="span">
              <li className="flex justify-center text-center items-center bg-white rounded shadow  ">
                <NavLink
                  to="/quotations"
                  className={({ isActive }) =>
                    isActive
                      ? "font-medium text-indigo-500 flex items-center"
                      : "font-medium flex items-center"
                  }
                >
                  <div className="flex flex-col justify-center items-center p-1">
                    <img
                      src={fileEdit}
                      alt="quotation-icon"
                      className="w-6 h-6"
                    />

                    <span className="text-[11px]">Quotation</span>
                  </div>

                </NavLink>
              </li>
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: '0px',
              margin: "0px 0px 4px 0px !important",
            }}
          >
            <li className="flex justify-center text-center items-center bg-white rounded shadow ">
              <NavLink
                to="/quotationsList"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium text-indigo-500 flex items-center"
                    : "font-medium flex items-center"
                }
              >   
                <div className="flex flex-col justify-center items-center p-1 ">
                  <img src={file} alt="quotation-icon" className="w-6 h-6" /> 
                  <span className="text-xs">List</span>
                </div>

                {/* <AiOutlineUser/> */}
          {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } 
              </NavLink>
            </li>
          </AccordionDetails>
        </Accordion> */}

          {/* /////////////////////Quotation //////////////////////////////////////////// */}

          {/* <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full">
          <NavLink
            to="/quotations"
            className={({ isActive }) =>
              isActive
                ? "font-medium text-indigo-500 flex items-center"
                : "font-medium flex items-center"
            }
          >
            <div className="flex flex-col justify-center items-center p-1">

              <AiOutlineFileText className="w-6 h-6" />
              <span className="text-xs">Quotations List</span>
            </div>

            {/* <AiOutlineUser/> */}
          {/* {isOpen && 
        <span className='ml-2'>Leads</span>  
           } 
          </NavLink>
        </li> */}

          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full">
            <NavLink
              to="/contacts"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center text-center p-1">
                <AiOutlineTeam className="w-6 h-6" />
                <span className="text-xs">Contacts</span>
              </div>

              {/* <AiOutlineTeam   /> */}
              {/* {isOpen &&
            <span className='ml-2'>Contacts</span>
            } */}
            </NavLink>
          </li>

          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full">
            <NavLink
              to="/emails"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center text-center p-1">
                <AiOutlineMail className="w-6 h-6" />
                <span className="text-xs">Emails</span>
              </div>

              {/* <AiOutlineMail   /> */}
              {/* {isOpen && 
        <span className='ml-2'>Emails</span>  
           } */}
            </NavLink>
          </li>

          <li className="flex justify-center text-left items-left bg-white rounded shadow p-1 w-full">
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                isActive
                  ? "font-medium text-indigo-500 flex items-center"
                  : "font-medium flex items-center"
              }
            >
              <div className="flex flex-col justify-center items-center text-center p-1">
                <AiOutlineSetting className="w-6 h-6" />
                <span className="text-xs ">Settings</span>
              </div>

              {/* <AiOutlineSetting className=' mr-2'   /> */}
              {/* {isOpen && 
        <span className='ml-2'>Settings</span>  
           } */}
            </NavLink>
          </li>


          <li className="flex justify-center text-center items-center bg-white rounded shadow p-1 w-full my-4 ">
              <NavLink
                to="/jobs"
                className={({ isActive }) =>
                  isActive
                    ? "font-medium text-indigo-500 flex items-center"
                    : "font-medium  flex items-center"
                }
              >
                <div className="flex flex-col justify-center items-center p-1">
                  <AiOutlineForm className="w-6 h-6" />
                  <span className="text-xs">Jobs</span>
                </div>
              </NavLink>
            </li>

          <div className="">
            <button onClick={onSignOut} className="flex justify-center items-center w-full bg-red-500 text-white p-2 rounded">

              <div className="flex flex-col justify-center items-center text-center ">
                <AiOutlineExport className="w-6 h-6" />
                <span className="text-xs">Sign Out</span>
              </div>


            </button>
          </div>


        </ul>

        {/* Sign Out */}
        {/* <div className="absolute bottom-4 left-4 right-4"> */}
        {/* <div className="absolute bottom-4 left-4 right-4">
        <button className="flex justify-center items-center w-full bg-red-500 text-white p-2 rounded">
          <div className="flex flex-col justify-center items-center text-center ">
            <AiOutlineExport className="w-6 h-6" />
            <span className="text-xs">Sign Out</span>
          </div> */}

        {/* <AiOutlineExport /> */}
        {/* {isOpen && <span className="ml-2">Sign Out</span>} */}
        {/* </button>
      </div> */}
      </aside>
    </div>
  );
};

export default Sidebar;
